import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import {
  FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER,
  UPLOAD_DC_APP_PARENT_MAPPING_BY_PARTNER,
  CLEAR_UPLOAD_DC_APP_PARENT_MAPPING_RESULT,
} from './types';
import { fetchDcAppParentMappingByPartner, uploadDcAppParentMappingByPartner } from '../../api';
import { downloadDcAppParentMappingCSV } from 'util/mac/downloadCSV';
import { DcAppParentMapping } from '../../api/fetchDcAppParentMapping';

/**
 * Action to fetch DC App Parent Mapping for a given partner and download as CSV
 * On success, automatically downloads a CSV file with columns: app_account_id, parent_account_id
 * @param partnerId - The partner ID to fetch mappings for
 */
export const fetchDcAppParentMapping =
  (partnerId: string) => (dispatch: Dispatch, getState: GetState) => {
    if (!partnerId) return;

    const state = getState();
    const fetchPromise = fetchDcAppParentMappingByPartner(partnerId, state).then((result) => {
      if (result && Array.isArray(result)) {
        downloadDcAppParentMappingCSV(result, partnerId);
      }
      return result;
    });

    dispatch(
      thunkProgress(FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER, fetchPromise, {
        partnerId,
      }),
    );
  };

/**
 * Action to upload DC App Parent Mapping CSV data for a given partner
 * Sends parsed CSV rows as POST /public/rest/account/dcAppParentMapping/partner/{partner_id}
 * @param partnerId - The partner ID to upload mappings for
 * @param mappings - Array of parsed app-to-parent account mappings from the CSV
 */
export const clearUploadDcAppParentMappingResult = () => ({
  type: CLEAR_UPLOAD_DC_APP_PARENT_MAPPING_RESULT,
});

export const uploadDcAppParentMapping =
  (partnerId: string, mappings: DcAppParentMapping[]) =>
  (dispatch: Dispatch, getState: GetState) => {
    if (!partnerId || !mappings?.length) return;

    const state = getState();
    const uploadPromise = uploadDcAppParentMappingByPartner(partnerId, mappings, state);

    dispatch(
      thunkProgress(UPLOAD_DC_APP_PARENT_MAPPING_BY_PARTNER, uploadPromise, {
        partnerId,
      }),
    );
  };
